var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46527 13.1479H14.3499M1.6499 13.1479L5.20428 12.4317C5.39297 12.3937 5.56622 12.3008 5.70229 12.1646L13.6591 4.20346C14.0406 3.82176 14.0403 3.20305 13.6585 2.82167L11.973 1.13804C11.5913 0.75682 10.9729 0.75708 10.5916 1.13862L2.63396 9.10062C2.49816 9.23649 2.40543 9.4094 2.36738 9.5977L1.6499 13.1479Z",
    stroke: "#898E99",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.167567e4fc15ed59827967e9a1130d40.svg";
export { ForwardRef as ReactComponent };